import React from 'react';
import Card from '../../Card';
import DegradedBanner from '../DegradedBanner';

const GRADE_COLOR = { '初阶': '#d97706', '进阶': '#2563eb', '熟练': '#16a34a', '高阶': '#7c3aed' };

/**
 * V4 P1：综合得分 + 用户画像（≥200 字）。
 *
 * narrative_v4.portrait = { text, model_used, degraded, attempts }
 * core = { total_score, grade, answered_count, total_questions, ... }
 */
export default function V4P1Portrait({ report }) {
  const core = report?.core || {};
  const portrait = report?.narrative_v4?.portrait || {};
  const grade = core.grade;
  const gradeColor = GRADE_COLOR[grade] || '#2563eb';
  const portraitText = portrait.text || '';

  return (
    <div data-testid="report-v4-p1">
      <Card style={{
        textAlign: 'center', padding: '40px 32px', marginBottom: 24,
        background: 'linear-gradient(135deg,#1a3a6b,#2d5aa0)', color: '#fff', border: 'none',
      }}>
        <p style={{ fontSize: 13, letterSpacing: 2, opacity: 0.7, marginBottom: 8 }}>您的 AIQ 测评得分</p>
        <div style={{ fontSize: 72, fontWeight: 900, lineHeight: 1, marginBottom: 12 }}>
          {core.total_score ?? '—'}
        </div>
        {grade && (
          <div style={{
            display: 'inline-block', padding: '6px 20px', borderRadius: 24,
            background: gradeColor, fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: 12,
          }}>
            {grade}
          </div>
        )}
        <p style={{ opacity: 0.6, fontSize: 13, margin: 0 }}>
          共作答 {core.answered_count ?? '—'}/{core.total_questions ?? '—'} 题
        </p>
      </Card>

      <Card
        data-testid="report-v4-p1-portrait"
        style={{ padding: '24px 28px', marginBottom: 24, borderLeft: '4px solid var(--color-primary, #1a3a6b)' }}
      >
        <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, color: 'var(--color-text-muted, #64748b)', letterSpacing: 1 }}>
          综合得分画像
        </h3>
        {portrait.degraded && <DegradedBanner />}
        <p style={{
          fontSize: 15, lineHeight: 1.85, color: 'var(--color-text)',
          whiteSpace: 'pre-wrap', margin: 0,
        }}>
          {portraitText || '（暂无内容）'}
        </p>
      </Card>
    </div>
  );
}
